@import (reference) '../../../../../constants/spacing.module.less';

.margin {
  margin: @space-16;
}
